// extracted by mini-css-extract-plugin
export default {"title":"SearchOptions_title__80Nji","option":"SearchOptions_option__RJkAl"};